import { render, staticRenderFns } from "./HomeUser.vue?vue&type=template&id=239f97d6&"
import script from "./HomeUser.vue?vue&type=script&lang=ts&"
export * from "./HomeUser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports